import React, { useState } from "react";

import Button, { ButtonSecondary } from "../UI/Button";
import { openCalendly } from "./calendly";
import TrialForm from "./TrialForm";

import heroBackground from "../../assets/product/productLMS1.jpg";

const HeroSection = () => {
  const [isTrialOpen, setIsTrialOpen] = useState(false);

  return (
    <>
      <TrialForm isOpen={isTrialOpen} onClose={() => setIsTrialOpen(false)} />
      <section className="container text-primary">
        <div
          className="relative w-full min-h-[10rem] lg:min-h-[15rem] py-10 bg-no-repeat bg-cover bg-center flex flex-col justify-center items-center rounded-xl"
          style={{ backgroundImage: `url(${heroBackground})` }}
        >
          <div className="absolute top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 rounded-xl"></div>
          <div className="relative text-tertiary text-center px-4">
            <h1 className="text-2xl lg:text-4xl font-bold">
              Learning Management System
            </h1>
            <div className="flex flex-col sm:flex-row justify-center items-stretch gap-3 mt-6 mx-auto w-full max-w-[17rem] sm:max-w-none sm:w-auto [&_button]:w-full sm:[&_button]:w-auto">
              <Button onClick={openCalendly}>Book a demo</Button>
              <ButtonSecondary onClick={() => setIsTrialOpen(true)}>
                Try LMS Now – Free Access
              </ButtonSecondary>
            </div>
          </div>
        </div>
        <div className="text-center px-4 pt-10 lg:pt-12">
          <h2 className="text-xl lg:text-3xl font-bold text-quaternary">
            One powerful platform for every learning stakeholder
          </h2>
          <p className="pt-3 mx-auto text-base lg:text-lg">
            A White-Label, AI-Powered, Customized Moodle LMS Built for
            University-Scale Deployment.
          </p>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
